import { useMutation, useQueryClient } from "@tanstack/react-query";
import type {
  PaymentLinkCreateRequestType,
  PaymentLinkCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2Request, apiV2AssertResponse } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePaymentLinkCreate = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PaymentLinkCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "payment-link",
        data,
      }).then(
        (data) => apiV2AssertResponse<PaymentLinkCreateResponseType>(data).data,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders],
      });
    },
  });
};
